module.exports = __webpack_public_path__ + "static/media/Vazir-FD.bfedee5c.woff";